<div class="row">
  <div class="col-lg-12 grid-margin">
    <div class="card">
      <div class="card-body upper-header">
        <div class="row">
          <div class="form-group col-3 ml-2">
            <label>Dharmshala</label>
            <select class="form-control border-primary" name="dharmshala_id" [(ngModel)]="selectedDharmshalaId" (ngModelChange)="onDharmshalaChange()">
              <option value="">All Dharmshalas</option>
              <option *ngFor="let dharmshala of allDharmshalas" [value]="dharmshala.id">{{dharmshala.name}}</option>
            </select>
          </div>
        </div>
        <h4 class="card-title">
          <div class="d-flex bd-highlight">
            <div class="p-2 flex-grow-1 bd-highlight">Blocked Rooms Configuration</div>
          </div>
        </h4>
        <div class="table-responsive" *ngIf="filteredRooms && filteredRooms.length">
          <table class="table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Dharmshala Name</th>
                <th>Room Type</th>
                <th>Total Rooms</th>
                <th>Blocked Rooms</th>
                <th>Block Release Days</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let room of filteredRooms; let i = index">
                <td>{{i+1}}</td>
                <td>{{room?.dharmshala?.name}}</td>
                <td>{{room?.room_type?.title}}</td>
                <td>{{room?.no_of_rooms}}</td>
                <td>{{room?.blocked_rooms}}</td>
                <td>
                  <span *ngIf="room?.block_release_days === 0">Never Release</span>
                  <span *ngIf="room?.block_release_days > 0">{{room?.block_release_days}} day(s) before</span>
                </td>
                <td>
                  <button class="btn btn-sm btn-primary" (click)="editRoom(room)">
                    <i class="fa fa-edit"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="p-12" *ngIf="!filteredRooms || !filteredRooms.length">
          <span class="ng-star-inserted no_data">No Data found.</span>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Edit Modal -->
<div class="modal fade show" *ngIf="editingRoom" style="display: block; background-color: rgba(0,0,0,0.5);">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Configure Blocked Rooms</h5>
        <button type="button" class="btn-close" (click)="cancelEdit()"></button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label>Blocked Rooms*</label>
          <input type="number" class="form-control border-primary" placeholder="Enter blocked rooms" [(ngModel)]="editingRoom.blocked_rooms" min="0" [max]="editingRoom.no_of_rooms">
          <small class="text-muted">Number of rooms blocked from booking (0 to {{editingRoom.no_of_rooms}})</small>
        </div>
        <div class="form-group mt-3">
          <label>Block Release Days*</label>
          <input type="number" class="form-control border-primary" placeholder="Enter block release days" [(ngModel)]="editingRoom.block_release_days" min="0">
          <small class="text-muted">Number of days (0 = never released)</small>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="cancelEdit()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="updateRoom()">Update</button>
      </div>
    </div>
  </div>
</div>
